export const messages = {
  en: {
    reportCustomComponentFooterManage: {
      statistics: 'Statistics',
      id: 'ID',
      name: 'Name',
      queryMethod: 'Query Method',
      description: 'Description',
      operation: 'Operation',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete component statistics',
      nameRequired: 'Required, please fill in the name',
      queryMethodRequired: 'Required, please select query method',
      sqlOptional: 'Optional, please fill in the SQL',
      javaOptional: 'Optional, please fill in the Java script',
      descriptionOptional: 'Optional, please fill in the description'
    },
    common: {
      back: 'Back',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      confirmDelete: 'Confirm Delete',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    reportCustomComponentFooterManage: {
      statistics: '统计',
      id: 'ID',
      name: '名称',
      queryMethod: '查询方式',
      description: '描述',
      operation: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除组件统计',
      nameRequired: '必填，请填写名称',
      queryMethodRequired: '必填，请选择查询方式',
      sqlOptional: '选填，请填写执行SQL',
      javaOptional: '选填，请填写执行Java脚本代码',
      descriptionOptional: '选填，请填写描述'
    },
    common: {
      back: '返回',
      add: '添加',
      edit: '修改',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      confirmDelete: '确认删除',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}